(ns kyber.styles.notifier)

(def alert-z-index 99)
(def toast-z-index 100)

(defn base-button-styles
  [gs]
  {:display :flex
   :justify-content :center
   :height :fit-content
   :appearance :none
   :align-items :center
   :width (str "calc(50% - " (gs [:spacing :p8]) ")")
   :text-transform :capitalize
   :padding [[(gs [:spacing :p16])
              (gs [:spacing :p28])]]
   :border-radius (gs [:radius :r3])
   :cursor :pointer
   :user-select :none
   :transition "all 100ms linear"
   :font-family (gs [:font-family :open-sans])
   :font-size (gs [:font-size :body-20])
   :font-weight (gs [:font-weight :title-10])
   :line-height (gs [:font-height :body-20])
   :white-space :nowrap})

(defn notifier-styles
  [gs]
  {".notifier-toast"
   {:position :fixed
    :z-index toast-z-index
    :transition "top 0.4s ease"
    :height :auto
    :top (gs [:spacing :p20])
    :left "50%"
    :transform "translate(-50%, 0)"
    :padding [[(gs [:spacing :p12])
               (gs [:spacing :p20])]]
    :margin (gs [:spacing :p0])
    :width "auto"
    :box-shadow (gs [:shadows :shadow-12])
    :font-family (gs [:font-family :open-sans])
    :font-size (gs [:font-size :caption-20])
    :font-weight (gs [:font-weight :caption-20])
    :line-height (gs [:font-height :caption-20])
    :border-radius (gs [:radius :r3])}

   ".info-toast"
   {:background-color (gs [:colors :gray-scale-600])
    :color (gs [:colors :true-white])}

   ".error-toast"
   {:background-color (gs [:colors :error-500])
    :color (gs [:colors :true-white])}

   ".notifier-underlay"
   {:position :fixed
    :z-index alert-z-index
    :top 0
    :bottom 0
    :left 0
    :right 0
    :width "100%"
    :height "100%"
    :background (gs [:overlay :gray])
    :display :flex
    :justify-content :center
    :align-items :center
    :overflow :hidden}

   ".notifier-alert"
   {:max-width "420px"
    :background-color (gs [:colors :gray-scale-50])
    :padding (gs [:spacing :p40])
    :border-radius (gs [:radius :r3])
    :display :flex
    :flex-wrap :wrap
    :justify-content :center}

   ".notifier-alert-title"
   {:font-family (gs [:font-family :open-sans])
    :font-size (gs [:font-size :title-10])
    :font-weight (gs [:font-weight :title-10])
    :line-height (gs [:font-height :title-10])
    :text-align :center
    :width "100%"
    :color (gs [:colors :gray-scale-600])
    :margin-bottom (gs [:spacing :p12])}

   ".notifier-alert-message"
   {:font-family (gs [:font-family :open-sans])
    :font-size (gs [:font-size :body-20])
    :font-weight (gs [:font-weight :body-20])
    :line-height (gs [:font-height :body-20])
    :color (gs [:colors :gray-scale-500])
    :text-align :center
    :margin-bottom (gs [:spacing :p12])
    :width "100%"}

   ".notifier-alert-deny-button"
   (merge (base-button-styles gs)
          {:border :none
           :background (gs [:colors :true-white])
           :margin-left (gs [:spacing :p12])
           :box-shadow (str "inset 0 0 0 1px " (gs [:colors :gray-scale-300]))
           :border-width (gs [:spacing :p1])
           :color (gs [:colors :primary-lite-600])
           "&:focus" {:outline (gs [:spacing :p0])
                      :border-image :none}

           "&:active" {:background-color (gs [:colors :primary-lite-400])
                       :border-color (gs [:colors :primary-lite-400])
                       :color (gs [:colors :true-white])}
           "&:disabled" {:border-color (gs [:colors :gray-scale-200])
                         :background :none
                         :color (gs [:colors :gray-scale-300])}

           (gs [:queries :hover])
           {"&:hover" {:background-color (gs [:colors :primary-lite-700])
                      :border-color (gs [:colors :primary-lite-700])
                      :color (gs [:colors :true-white])}
            "&:disabled:hover" {:color (gs [:colors :gray-scale-300])}}})

   ".notifier-alert-confirm-button"
   (merge (base-button-styles gs)
          {:border :none
           :background (gs [:colors :true-white])
           :box-shadow (str "inset 0 0 0 1px " (gs [:colors :gray-scale-300]))
           :border-width (gs [:spacing :p1])
           :color (gs [:colors :primary-lite-600])
           "&:focus" {:outline (gs [:spacing :p0])
                      :border-image :none}

           "&:active" {:background-color (gs [:colors :primary-lite-400])
                       :border-color (gs [:colors :primary-lite-400])
                       :color (gs [:colors :true-white])}
           "&:disabled" {:border-color (gs [:colors :gray-scale-200])
                         :background :none
                         :color (gs [:colors :gray-scale-300])}

           (gs [:queries :hover])
           {"&:hover" {:background-color (gs [:colors :primary-lite-700])
                      :border-color (gs [:colors :primary-lite-700])
                      :color (gs [:colors :true-white])}
            "&:disabled:hover" {:color (gs [:colors :gray-scale-300])}}})})
